import {
  HStack,
  Icon,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import { Stack } from '@chakra-ui/layout';
import { BsFillInfoCircleFill } from 'react-icons/all';
import { FiSearch, FiX } from 'react-icons/fi';
import { Button, Heading, Input } from '~/components';
import { FileUploader } from '~/components/FileInput';

export const TerminationAgreement: React.VFC<{
  baixarTermoRescisao?: () => void;
  arquivoSubstituido?: (file: File | null) => void;
}> = ({ arquivoSubstituido, baixarTermoRescisao }) => {
  const [arquivo, setArquivo] = useState<File | null>(null);
  return (
    <Stack gridGap={3}>
      <Heading fontSize="18px">
        Revise o Termo de Rescisão que será enviado ao cliente via DocuSign ou
        anexe a sua versão:
      </Heading>
      <HStack>
        <Button type="button" onClick={baixarTermoRescisao}>
          Baixar Termo de Rescisão.doc
        </Button>
      </HStack>
      <Stack>
        <HStack>
          <Text fontSize="18px" fontWeight="bold">
            Anexar Termo de Rescisão:
          </Text>
          <Tooltip
            hasArrow
            label="Anexar arquivo do tipo pdf. O limite total do arquivo é de 10MB."
            bg="black"
            shouldWrapChildren
          >
            <Icon as={BsFillInfoCircleFill} />
          </Tooltip>
        </HStack>
        <HStack>
          <FileUploader
            label=""
            isDisabled={false}
            isRequired={false}
            fileName={arquivo?.name}
            onChange={file => {
              arquivoSubstituido && arquivoSubstituido(file);
              setArquivo(file);
            }}
            clearFile={() => {
              arquivoSubstituido && arquivoSubstituido(null);
              setArquivo(null);
            }}
            showButton
          />
        </HStack>
      </Stack>
    </Stack>
  );
};
